import React from 'react'
import { connect } from 'react-redux'
import { getBrandClassName, getItinerary } from '../../reducers/packageDetails'
import EQuotePackageAdditionalDetailsForm from '../forms/EQuotePackageAdditionalDetailsForm'
import EQuotePreviewPackageOutline from '../../components/outline/EQuotePreviewPackageOutline'
import '../../styles/scss/components/equote-package-request-details.scss'
import { getActivePackageData } from '../../reducers/activePackage'
import { getSingleBrandDetails } from '../../reducers/brands'

const EQuoteRequestMoreDetailsContent = props => {
  const { brandClassName, packageDetails, itinerary, brandDetails } = props
  return (
    <div
      className={`equote-package-request-details ${brandClassName} u-content-container`}
    >
      <h2>Request This Sailing</h2>
      <div className="equote-package-request-details-container">
        <div className="equote-package-request-details-form-container">
          <div
            className={`equote-package-request-details-preview-wrapper ${brandClassName}`}
          >
            <EQuotePreviewPackageOutline
              packageDetails={packageDetails}
              itinerary={itinerary}
              currentBrand={brandDetails}
            />
          </div>
          <EQuotePackageAdditionalDetailsForm
            packageDetails={packageDetails}
            initialValues={{
              'Contact method': 'Email',
              'Dates are flexible': props.sailDate ? 'Yes' : 'No',
              Date: props.sailDate
            }}
          />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    packageDetails: getActivePackageData(state),
    itinerary: getItinerary(state),
    brandClassName: getBrandClassName(state),
    currentStep: state.appState.currentStep,
    brandDetails: getSingleBrandDetails(state),
    sailDate:
      state.form['EQuotePackageAdditionalDetailsForm'] &&
      state.form['EQuotePackageAdditionalDetailsForm'].values
        ? state.form['EQuotePackageAdditionalDetailsForm'].values.Date
        : null
  }
}

export default connect(mapStateToProps)(EQuoteRequestMoreDetailsContent)
